import { AuthHttp } from 'angular2-jwt';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Http, Response, ResponseContentType } from '@angular/http';



@Injectable()
export class VolunteerSubsriptionService {

  constructor(private authHttp: AuthHttp) { }

  

  addVolunteerSub(volunteerSub: any) {
    return this.authHttp.post("/api/volunteer/subscribe", volunteerSub).map( res =>{
        return {'status': res.status, 'value':res.json() }
      } )
  }

// Activities

  getAllVolunteerActivities(){
    return this.authHttp.get("/api/volunteer/activity/all").map( res =>{
      return {'status': res.status, 'value':res.json() }
    } )
  }

  getAllYearsOfVolunteerActivity(){
    return this.authHttp.get("/api/volunteer/activity/GetAllYearsOfVolunteerActivities/").map(res => {
      let value = "";
      if (res.status == 200){
          value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }

  getAllVolunteerActivitiesByYear(year:number){
    return this.authHttp.get("/api/volunteer/activity/year/"+year).map(res => {
      let value = "";
      if (res.status == 200){
          value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }

  getVolunteerActivityById(id:number){
    return this.authHttp.get("/api/volunteer/activity/byId/"+id).map(res => {
      let value = "";
      if (res.status == 200){
          value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }
  
  changeClosedActivity(id: number, open: boolean){
    return this.authHttp.get("/api/volunteer/activity/open/"+id+"/"+open).map(res => {
      let value = "";
      if (res.status == 200){
          value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }

  deleteActivity(id: number){
    return this.authHttp.delete('/api/volunteer/activity/'+id).map( res=> {
      let value = "";
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }
  
  createNewActivity(newActivity:any){
    return this.authHttp.post('/api/volunteer/activity/new',newActivity).map( res=> {
      let value = "";
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    }); 
  }

  updateActivity(activity: any){
    return this.authHttp.put('/api/volunteer/activity/update', activity).map(res =>{
      let value = "";
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }

//  Subscribers

  getAllVolunteerSubscriptionsForActivity(id: number){
    return this.authHttp.get("/api/volunteer/subscriptions/byId/"+id).map(res => {
      let value = "";
      if (res.status == 200){
          value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
    
  }

  getAllMemberVolunteerSubscriptionsForActivity(id: number){
    return this.authHttp.get("/api/volunteer/membersubscriptions/byId/"+id).map(res => {
      let value = "";
      if (res.status == 200){
          value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
    
  }

  deleteSubsciptionFromActivity(id:number){
    return this.authHttp.delete('/api/volunteer/subscription/'+id).map( res=> {
      let value = "";
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }

  getAllMemberSubscriptions(id: number){
    return this.authHttp.get('/api/volunteer/subscriptions/byUser/'+id).map( res=> {
      let value = "";
      if (res.status == 200){
        value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }


  downloadExcel(id: number){
    return this.authHttp.get('/api/volunteer/subscriptions/generateXlsx/'+id, { responseType: ResponseContentType.Blob }).map((res: Response) => {
      return res;
    });
  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/volunteerSubscription.service.ts